import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import { primary } from './../../theme/colors'
import { Link } from 'react-router-dom';
import Btn from '../Btn/Btn';
import './Header.css';


import { Menu, MenuButton, MenuItem, MenuDivider } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { useNavigate } from 'react-router-dom';
import MenuMobile from '../MenuMobile/MenuMobile';
import getImage from '../../useFull/getImage';


const Header = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const {
        btnClient,
        listMenu
    } = require(`../../assets/languages/${language}/header.json`);
    const navigate = useNavigate()

    return (
        <>
            <section className="container">
                <div className='container-header'>
                    <div className="container-header-logo">
                        <div style={{ backgroundImage: `url(${getImage('', 'logo.png')})`, width: '234px', height: '38px' }} onClick={() => navigate(`${language === 'pt-br' ? '/ ' : `/${language}`}`)}></div>
                    </div>
                    <div className="container-header-logo-small">
                        <div className="bg-icon" style={{ backgroundImage: `url(${getImage('', 'logo-small.png')})`, width: '50px', height: '38px' }} onClick={() => navigate(`${language === 'pt-br' ? '/ ' : `/${language}`}`)}></div>
                    </div>
                    <div className="container-header-menu">
                        {listMenu?.map((d, key) => (
                            <div key={key}>
                                <Menu menuButton={<MenuButton className="dropdown-title white100">
                                    {d.title}
                                    <div className='arrow-up' style={{ backgroundImage: `url(${getImage('icons', 'arrow-orange.png')})`, width: '17px', height: '11px', marginLeft: '10px' }}></div>
                                </MenuButton>}>
                                    {d?.itens?.map((item, index) => (
                                        <div key={index} className="dropdown-itens"  onClick={() => navigate(`${language === 'pt-br' ? item.value : `${item.value}/${language}`}`)}>
                                            <MenuItem className="dropdown-label">
                                                <Link to={item.value} className="dropdown-label">{item.label}</Link>
                                            </MenuItem>
                                            {index + 1 < d.itens.length && <MenuDivider className="dropdown-divider" />}
                                        </div>
                                    ))}
                                </Menu>
                            </div>
                        ))}
                    </div>
                    <div className='menu-mobile'>
                        <MenuMobile
                            data={listMenu}
                            btnClient={btnClient}
                        />
                    </div>

                    <div className="container-header-search d-none">
                        <div style={{ backgroundImage: `url(${getImage('icons', 'search.png')})`, width: '20px', height: '20px' }}></div>
                    </div>
                    <Btn color={primary.primary300} label={btnClient} iconName={'iconbtnclient.png'} className='d-none' />
                    <div className='header-relprev d-none'>
                        <span onClick={() => navigate(`${language === 'pt-br' ? '/security-report' : ``}`)} className='header-relprev-content'>RELPREV</span>
                    </div>
                </div>
            </section>
            <div className='header-space'>
            </div>
        </>
    );
}
export default Header;
